import React from 'react';
import { useTranslation } from 'react-i18next';
import { AppButton, Box, HeadsetIcon, Inscription, useResponsive } from '@common-fe/common-fe';

interface Props {
  onAddNew: () => void;
}

const AuthorizedUsersHeader = ({ onAddNew }: Props) => {
  const { t } = useTranslation();
  const { isMobile } = useResponsive();

  return (
    <Box direction={isMobile ? 'column' : 'row'} justify={isMobile ? undefined : 'between'} align={isMobile ? undefined : 'center'}>
      <Box direction="row" align="center" gap="spacing16" flex>
        <Box pad="spacing4" flex={{ shrink: 0 }}>
          <HeadsetIcon size="50px" color="iconDisabled" />
        </Box>
        <Box gap="spacing2" style={isMobile ? undefined : { minWidth: 0 }}>
          <Inscription size="large" weight={700} color="text">
            {t('Call Center Authorized Users')}
          </Inscription>
          <Inscription size="small" weight={500} color="textSecondary">
            {t('Identify additional individuals who are allowed to be provided with account information when contacting call center.')}
          </Inscription>
        </Box>
      </Box>
      <Box margin={{ top: isMobile ? 'spacing16' : undefined }}>
        <AppButton
          testId="authorized-users_add-new"
          buttonType="secondary"
          width={isMobile ? '100%' : '116px'}
          onClick={onAddNew}
        >
          {t('Add New')}
        </AppButton>
      </Box>
    </Box>
  );
};

export default AuthorizedUsersHeader;
